import { render, staticRenderFns } from "./ModalidadeContratoList.vue?vue&type=template&id=1e837ab6"
import script from "./ModalidadeContratoList.vue?vue&type=script&lang=js"
export * from "./ModalidadeContratoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports